import {UPDATE_PATH} from "../actions";

const places = (state = {type: "LineString", coordinates: []}, action) => {
    switch (action.type) {
        case UPDATE_PATH:
            return action.geometry;
        default:
            return state
    }
};

export default places
